import {h, Fragment} from "preact"
import { useProductFilters } from '@nosto/preact'

export default function SelectedFilters({ className }) {
    const { filters, removeAll } = useProductFilters();

    return filters.length > 0 &&
        <div class={`active-facets active-facets-desktop ${className}`}>
            <div class="active-facets-vertical-filter">
                <h2 
                    class="facets__heading facets__heading--vertical facets__text text-body"
                    id="verticalTitle"
                    tabindex="-1"
                >
                    Filtrar:{' '}
                </h2>
                <div class="active-facets__button-wrapper">
                    <a
                        href="javascript:void(0)"
                        class="active-facets__button-remove underlined-link"
                        role="button"
                        onClick={removeAll}
                        aria-label="Borrar todos los filtros"
                    >
                        <span>Borrar Todo</span>
                    </a>
                </div>
            </div>
            <>
            {filters.map(filter => (
                <a 
                    class="active-facets__button active-facets__button--light" 
                    onClick={() => filter.remove()}
                    role="button"
                >
                    <div class="active-facets__pickup">
                        <p class="active-facets__pickup-text">
                            {filter.name}: {filter.value}
                        </p>
                        <svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
                            <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <span class="visually-hidden">Borrar filtro</span>
                    </div>
                </a>
            ))}
            </>
        </div>
}
